import React from 'react';
import {
  CContainer, CRow, CCol, CCard, CCardBody, CCardHeader,
  CBreadcrumb, CBreadcrumbItem
} from '@coreui/react';
import { useNavigate } from 'react-router-dom';
import ColorInputs from '../../components/ColorInputs/ColorInputs';
import { connect } from 'react-redux';
import { createColorRequestAction } from '../../store/color/colorActions';
import { useTranslation } from '../../hooks/useTranslation';

const CreateColor = ({ createColorRequest, isLoading, createColorData }) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleSubmit = (data) => {
    createColorRequest({ data, navigate });
  };

  const handleCancel = () => {
    navigate('/color');
  };

  return (
    <CContainer>
      <CBreadcrumb className="mb-4">
        <CBreadcrumbItem href="#/color" onClick={(e) => { e.preventDefault(); handleCancel(); }}>
          {t('colors')}
        </CBreadcrumbItem>
        <CBreadcrumbItem active>{t('createColor')}</CBreadcrumbItem>
      </CBreadcrumb>

      <CRow>
        <CCol xs={12}>
          <CCard>
            <CCardHeader><h4>{t('createColor')}</h4></CCardHeader>
            <CCardBody>
              <ColorInputs
                onSubmit={handleSubmit}
                onCancel={handleCancel}
                isLoading={isLoading}
                submitResponse={createColorData}
              />
            </CCardBody>
          </CCard>
        </CCol>
      </CRow>
    </CContainer>
  );
};

const mapStateToProps = (state) => ({
  isLoading: state.loadingReducer.isLoading,
  createColorData: state.colorReducer.createColorData,
});

const mapDispatchToProps = (dispatch) => ({
  createColorRequest: (payload) => dispatch(createColorRequestAction(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CreateColor);
